<template>
  <div v-if="open" class="v-dialog__content v-dialog__content--active" style="z-index: 1000">
    <div class="v-dialog v-dialog--active v-dialog--fullscreen" style="transform-origin: center center;">
      <v-card class="d-flex align-items-center justify-content-center" color="light">
        <img class="nv-loading" src="@/assets/store/nievedeolla.gif" alt="">
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: ['open']
}
</script>
